import "./AnswerBoard.css"
import React, { useRef, useState, useEffect } from "react";
import { Test, QuestionGroup, Question, Option } from 'react-multiple-choice';
import AuthService from "../services/auth.service";

const initKey = 0;
const nullColor = "rgba(239,239,240,0.33)"
const rightColor = "rgba(76,175,80,0.33)";
const wrongColor = "rgba(255,0,0,0.33)";
const optNum = 5;

function AnswerBoard({ questionNum, totalQuestionNum, setIsNextQuestion, fetchedAnswers }) {
  const answerKey = useRef(initKey);
  const [isCorrect, setIsCorrect] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({});

  useEffect(() => {

    if (!isClickable()) {
      console.info(`[info] selected opts ${selectedOptions[questionNum]}`)
      AuthService.gameplay("sendAnswer",
          {
            "questionNum": questionNum,
            'ans': selectedOptions[questionNum]
          }
        )
        .then(async (res) => {
            if('isCorrect' in res.data) setIsCorrect(res.data['isCorrect']=='correct')
        })
        .catch((err) => {
          console.error('err: failed send answer', err);
        });
      setIsNextQuestion(true);
    }
  }, [selectedOptions]);

  useEffect(() => {
    if (questionNum > totalQuestionNum)
      return;
    answerKey.current += 1;
    setSelectedOptions(prev => ({}));
    setIsCorrect(null);
    console.info(`question ${questionNum} answer board reset`)

  }, [questionNum]);


  const isClickable = () => {
    return Object.keys(selectedOptions).length == 0;
  }

  const setSelectColor = () => {
    return (isCorrect==null) ? nullColor : ((isCorrect) ? rightColor : wrongColor);
  }

  const setSelectValue = () => {
    return (isCorrect==null) ? "" : ((isCorrect) ? "Correct" : "Wrong");
  }

  const genOpts = () => {
    const ret = [];

    for (let i = 0; i < optNum; i++) {
      if (isClickable()) {
        let src_link = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyHE587m3fzxYxTaoi884hdPUfgZBIiTb1jURaXLaP&s";
        let value_item = `Value ${i}`;
        
        // substitute with fetched answer if available
        if (i < fetchedAnswers.length) {
          const item = fetchedAnswers[i];
          if ('src_link' in item)
            src_link = item['src_link'];
          if ('value_item' in item)
            value_item = item['value_item'];
        }
        
        ret.push(
          <Option key={`key${i}`} value={`${i}`} style={{option: {width: "150%"} }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: "100%", fontSize: "18px" }}>
              <img src={src_link} alt="sample img" width="50px" height="50px" style={{ marginRight: "1.5vh" }} />
              {value_item}
            </div>
          </Option>
        );
        
      } else if (selectedOptions[questionNum] == i) {
        console.log('AB isCorrect',isCorrect);
        ret.push(
          
          <button key={`key${i}`} className="ans-button" style={{ backgroundColor: setSelectColor() }}>
            {setSelectValue()}
          </button>
        );
      }
    }

    return ret;
  }

  return (
    <div className="answer-board">
      <Test key={answerKey.current} style={{display:"inline-block",textAlign:"center",width:"auto",margin:"0"}} onOptionSelect={(opt) => { setSelectedOptions((prev) => ({ ...opt })); }}>
        <QuestionGroup questionNumber={questionNum} style={{width:"33vh",display:"block"}}>
          {genOpts()}
        </QuestionGroup>
      </Test>
    </div>
  );
}

export default AnswerBoard;